import { useState } from "react";
import { hotTopics } from "@/mocks/gossip";

const tagMap: Record<string, { chip: string; badge: string }> = {
  primary: { chip: "bg-primary-100 text-primary-800", badge: "bg-primary-500 text-background-50" },
  accent: { chip: "bg-accent-100 text-accent-800", badge: "bg-accent-500 text-background-50" },
  secondary: { chip: "bg-secondary-100 text-secondary-800", badge: "bg-secondary-600 text-background-50" },
};

const tagStyle = (key: string) => tagMap[key] ?? tagMap.primary;

export default function DailyDigest() {
  const [active, setActive] = useState(0);

  return (
    <section id="daily" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-sun-line"></i> 今日瓜田速览
            </p>
            <h2 className="serif-title mt-2 text-3xl font-black text-foreground-950 md:text-4xl">
              白天没空看，现在一篇补完
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-500">
            精选今日热度最高的六条瓜，点击可在下方预览详情，晚间汇总会再逐一复盘。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((item, i) => {
            const activeCard = active === i;
            const st = tagStyle(item.tagColor);
            return (
              <article
                key={item.id}
                onClick={() => setActive(i)}
                className={`group cursor-pointer rounded-2xl border p-5 transition-all duration-300 ${activeCard ? "border-primary-300 bg-background-100 shadow-card" : "border-background-200 bg-background-50 hover:border-background-300"}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${st.chip}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="serif-title mt-4 text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-800">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                  {activeCard ? hotTopics[active].summary : item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-fire-line text-primary-500"></i>
                    热度 {item.heat} 万
                  </span>
                  <span className="text-xs font-semibold text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                    看复盘 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-6 rounded-2xl border border-primary-200 bg-primary-50/60 p-5 md:p-6">
          <p className="flex flex-wrap items-start gap-2 text-sm leading-relaxed text-foreground-700">
            <i className="ri-sparkling-2-line mt-0.5 text-primary-500"></i>
            <span>
              <strong className="text-foreground-900">小编划重点：</strong>
              当前最受关注的当属
              <strong className="text-primary-700">「{hotTopics[active].title}」</strong>
              ——{hotTopics[active].summary} 完整时间线与后续回应请见下方「全瓜复盘」。
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}